import axios from "axios";

const BASE_URL = "/api/v1/saved-views";

const ApiSavedViews = {
  getSavedViews(params) {
    return axios.get(BASE_URL, { params });
  },

  getSavedViewById(id) {
    return axios.get(`${BASE_URL}/${id}`);
  },

  createSavedView(payload) {
    return axios.post(BASE_URL, payload);
  },

  updateSavedView(id, payload) {
    return axios.put(`${BASE_URL}/${id}`, payload);
  },

  deleteSavedView(id) {
    return axios.delete(`${BASE_URL}/${id}`);
  },
};

export default ApiSavedViews;